var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcongift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_31671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.043 1.67365C13.6959 1.67365 15.0359 3.01361 15.0359 4.66654C15.0359 5.21201 14.8899 5.72341 14.635 6.16381L18.0288 6.16298V7.65942H16.5323V15.1417C16.5323 15.5549 16.1974 15.8899 15.7841 15.8899H3.81254C3.39931 15.8899 3.06432 15.5549 3.06432 15.1417V7.65942H1.56787V6.16298L4.96164 6.16381C4.7067 5.72341 4.56076 5.21201 4.56076 4.66654C4.56076 3.01361 5.90073 1.67365 7.55366 1.67365C8.44795 1.67365 9.25064 2.06587 9.79901 2.68768C10.346 2.06587 11.1487 1.67365 12.043 1.67365ZM9.05012 7.65942H4.56076V14.3934H9.05012V7.65942ZM15.0359 7.65942H10.5466V14.3934H15.0359V7.65942ZM7.55366 3.17009C6.72719 3.17009 6.05721 3.84007 6.05721 4.66654C6.05721 5.45543 6.66767 6.10175 7.44198 6.15888L7.55366 6.16298H9.05012V4.66654C9.05012 3.91708 8.4992 3.29631 7.7802 3.18713L7.66534 3.17419L7.55366 3.17009ZM12.043 3.17009C11.2541 3.17009 10.6078 3.78055 10.5507 4.55486L10.5466 4.66654V6.16298H12.043C12.8319 6.16298 13.4782 5.55252 13.5353 4.77822L13.5395 4.66654C13.5395 3.84007 12.8695 3.17009 12.043 3.17009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_31671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9574,
    height: 17.9574,
    fill: "white",
    transform: "translate(0.815918 0.17511)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcongift);
export default __webpack_public_path__ + "static/media/icon.gift.727a9611f25853bd806e000b4f5c616f.svg";
export { ForwardRef as ReactComponent };